import React from 'react'
import { FontFamily, TextAlign } from '@gousto-internal/citrus-react'
import { useDietaryClaims } from '../../model/recipe/useRecipeDietaryClaims'
import { DietaryIcons } from './DietaryIcons.styled'

const dietaryAcronyms = {
  vegan: 'PB',
  vegetarian: 'V',
  dairy_free: 'DF',
  gluten_free: 'GF',
}
export const DietaryLabels = () => {
  const dietaryClaims = useDietaryClaims()

  return (
    <>
      {dietaryClaims?.map((claim) => (
        <DietaryIcons
          key={claim}
          fontFamily={FontFamily.Bold}
          size={2}
          textAlign={TextAlign.Center}
        >
          {dietaryAcronyms[claim]}
        </DietaryIcons>
      ))}
    </>
  )
}
